import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { listThreads } from '../../services/forumApi';
import { REST_API_ORIGIN } from '../../platform/endpoints';
import {
  EMOJI,
  authorLabel,
  normalizeThreadAuthor
} from '../../utils/forumUiHelpers';




//function isSeedThread(t) {
  //if (!t) return false;
  //const aid = t.authorId;
  //return !aid || aid === AUTHOR_SEED_ID || (typeof aid === 'object' && aid?._id === AUTHOR_SEED_ID);
//}







//function rtime(d) {
  //try {
    //const sec = Math.floor((Date.now() - new Date(d)) / 1000);
    //const units = [
      //[31536000, 'a'], [2592000, 'm'], [604800, 'sem'], [86400, 'd'], [3600, 'h'], [60, 'min']
    //];
    //for (const [s, label] of units) if (sec >= s) return `hace ${Math.floor(sec/s)} ${label}`;
    //return 'justo ahora';
  //} catch { return ''; }
//}


function threadStatus(count) {
  const n = Number(count || 0);
  if (n <= 0) return { translationKey: 'thread.status.active', kind: 'active' };
  if (n <= 4) return { translationKey: 'thread.status.open', kind: 'open' };
  return { translationKey: 'thread.status.live', kind: 'live' };
}

function normalizeAvatarUrl(url) {
  const raw = String(url || '').trim();
  if (!raw) return '';

  if (/^(https?:)?\/\//i.test(raw) || raw.startsWith('data:') || raw.startsWith('blob:')) {
    return raw;
  }

  const normalizedPath = raw.startsWith('/') ? raw : `/${raw}`;

  if (normalizedPath.startsWith('/uploads/') || normalizedPath.startsWith('/api/uploads/') || normalizedPath.startsWith('/avatars/')) {
    return `${REST_API_ORIGIN}${normalizedPath}`;
  }

  return normalizedPath;
}

function pickAvatarFromObject(obj) {
  if (!obj || typeof obj !== 'object') return '';

  return (
    obj.avatarUrl ||
    obj.avatarURL ||
    obj.avatar ||
    obj.photoURL ||
    obj.photoUrl ||
    obj.profileImage ||
    obj.profileImageUrl ||
    obj.profilePicture ||
    obj.profilePictureUrl ||
    obj.image ||
    obj.imageUrl ||
    obj.picture ||
    obj.pictureUrl ||
    obj.photo ||
    obj.photoUrl ||
    ''
  );
}

function getThreadAuthorAvatar(t) {
  const possibleAuthors = [
    t?.author,
    t?.user,
    t?.createdBy,
    t?.creator,
    t?.owner,
    t?.authorId,
    t?.userId,
    t?.authorProfile,
    t?.authorData,
    t?.authorSnapshot,
    t?.createdByUser,
    t?.createdByProfile,
  ];

  const directAvatar =
    t?.authorAvatar ||
    t?.authorAvatarUrl ||
    t?.authorPhoto ||
    t?.authorPhotoUrl ||
    t?.authorImage ||
    t?.authorImageUrl ||
    t?.avatarUrl ||
    t?.avatar ||
    t?.profileImage ||
    t?.profileImageUrl ||
    t?.userAvatar ||
    t?.userAvatarUrl ||
    '';

  const nestedAvatar = possibleAuthors.map(pickAvatarFromObject).find(Boolean) || '';

  return normalizeAvatarUrl(directAvatar || nestedAvatar);
}


const FORUM_SIGNS = [
  'capricornio',
  'acuario',
  'piscis',
  'aries',
  'tauro',
  'geminis',
  'cancer',
  'leo',
  'virgo',
  'libra',
  'escorpio',
  'sagitario',
];

const FORUM_LOAD_ERROR = '__zodiacus_forum_load_error__';

const SORT_TABS = [
  { key: 'recent', translationKey: 'sort.recent' },
  { key: 'views', translationKey: 'sort.popular', prefix: '🔥 ' },
  { key: 'replies', translationKey: 'sort.mostReplied', prefix: '💬 ' },
];

const HOME_ZODIAC_KEY_BY_FORUM_SIGN = {
  capricornio: 'capricorn',
  acuario: 'aquarius',
  piscis: 'pisces',
  aries: 'aries',
  tauro: 'taurus',
  geminis: 'gemini',
  cancer: 'cancer',
  leo: 'leo',
  virgo: 'virgo',
  libra: 'libra',
  escorpio: 'scorpio',
  sagitario: 'sagittarius',
};



export default function ForumCategory() {
  const { t: translate } = useTranslation(['forum', 'common', 'home']);
  const { sign } = useParams();
  const navigate = useNavigate();
  const categoryScrollerRef = useRef(null);
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ items: [], total: 0, limit: 20 });
  const [categoryTotals, setCategoryTotals] = useState({});
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const [hoverBack, setHoverBack] = useState(false);
  const [hoverCta, setHoverCta] = useState(false);
  const [hoverItem, setHoverItem] = useState(null);
  const [hoverPrev, setHoverPrev] = useState(false);
  const [hoverNext, setHoverNext] = useState(false);

  const [sortKey, setSortKey] = useState('recent'); // 'recent' | 'views' | 'replies'

  // Auto-refresh helpers
  const [refreshTick, setRefreshTick] = useState(0);

  const [carouselState, setCarouselState] = useState({ canLeft: false, canRight: true });

  const updateCarouselState = useCallback(() => {
    const scroller = categoryScrollerRef.current;
    if (!scroller) return;

    const maxLeft = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
    const currentLeft = scroller.scrollLeft || 0;

    setCarouselState({
      canLeft: currentLeft > 8,
      canRight: currentLeft < maxLeft - 8,
    });
  }, []);

  const scrollCategoryCarousel = useCallback((direction) => {
    const scroller = categoryScrollerRef.current;
    if (!scroller) return;

    const firstCard = scroller.querySelector('[data-forum-sign]');
    const cardWidth = firstCard?.getBoundingClientRect?.().width || 176;
    const gap = 14;
    const amount = Math.max(160, cardWidth + gap);

    scroller.scrollBy({
      left: direction === 'left' ? -amount : amount,
      behavior: 'smooth',
    });

    window.setTimeout(updateCarouselState, 260);
  }, [updateCarouselState]);

  // Guard: si no hay signo válido, volver al índice del foro
  useEffect(() => {
    if (!sign || typeof sign !== 'string') {
      navigate('/foro', { replace: true });
    }
  }, [sign, navigate]);

  // Refetch when tab regains focus / becomes visible
  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === 'visible') setRefreshTick(t => t + 1);
    };
    window.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', onVisible);
    return () => {
      window.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', onVisible);
    };
  }, []);

  // Light auto-refresh every 5 minutes (prudential, low server load)
  useEffect(() => {
    const id = setInterval(() => setRefreshTick(t => t + 1), 300000); // 5 * 60 * 1000
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    let alive = true;
    (async () => {
      if (!sign) return;
      try {
        setLoading(true);

        const responses = await Promise.all(
          FORUM_SIGNS.map(async (signKey) => {
            const d = await listThreads(signKey, { page: 1, limit: 100, sort: sortKey, _ts: Date.now() });
            const itemsNorm = Array.isArray(d.items)
              ? d.items.map((item) => ({
                  ...normalizeThreadAuthor(item),
                  categoryKey: item?.categoryKey || signKey,
                }))
              : [];

            return {
              signKey,
              total: Number(d?.total ?? itemsNorm.length ?? 0),
              items: itemsNorm,
            };
          })
        );

        if (!alive) return;

        const totals = responses.reduce((acc, row) => {
          acc[row.signKey] = row.total;
          return acc;
        }, {});

        // Mostrar únicamente los hilos del signo actualmente abierto.
        const activeResponse =
          responses.find((row) => row.signKey === sign) || {
            items: [],
            total: 0,
          };

        setCategoryTotals(totals);

        setData({
          items: activeResponse.items,
          total: activeResponse.total,
          limit: 20,
        });
        setPage(1);
        setErr('');
      } catch (e) {
        if (!alive) return;
        setErr(e.message || FORUM_LOAD_ERROR);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [sign, sortKey, refreshTick]);

  // Reset a la primera página al cambiar orden
  useEffect(() => { setPage(1); }, [sortKey]);

  useEffect(() => {
    if (!sign) return;

    const timer = window.setTimeout(() => {
      try {
        const scroller = categoryScrollerRef.current;
        if (!scroller) return;

        const activeCard = scroller.querySelector(`[data-forum-sign="${sign}"]`);
        if (!activeCard) return;

        const scrollerRect = scroller.getBoundingClientRect();
        const cardRect = activeCard.getBoundingClientRect();
        const currentLeft = scroller.scrollLeft;
        const targetLeft = currentLeft + cardRect.left - scrollerRect.left - (scrollerRect.width / 2) + (cardRect.width / 2);

        scroller.scrollTo({
          left: Math.max(0, targetLeft),
          behavior: 'smooth',
        });
      } catch {}
    }, 120);

    return () => window.clearTimeout(timer);
  }, [sign, categoryTotals]);


  useEffect(() => {
    updateCarouselState();

    const scroller = categoryScrollerRef.current;
    if (!scroller) return undefined;

    const onScroll = () => updateCarouselState();
    const onResize = () => updateCarouselState();

    scroller.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    const timer = window.setTimeout(updateCarouselState, 180);

    return () => {
      scroller.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      window.clearTimeout(timer);
    };
  }, [updateCarouselState, sign, categoryTotals]);

  const safeData = data && typeof data === 'object' ? data : { items: [], total: 0, limit: 20 };
  const totalPages = Math.max(1, Math.ceil((safeData.total || 0) / (safeData.limit || 20)));
  const items = Array.isArray(safeData.items) ? safeData.items : [];
  const sortedItems = [...items].sort((a, b) => {
    if (sortKey === 'replies') {
      const repliesA = Number(a?.counters?.visiblePosts ?? a?.counters?.posts ?? a?.postsCount ?? a?.replies ?? 0);
      const repliesB = Number(b?.counters?.visiblePosts ?? b?.counters?.posts ?? b?.postsCount ?? b?.replies ?? 0);
      return repliesB - repliesA;
    }

    if (sortKey === 'views') {
      const viewsA = Number(a?.counters?.views ?? a?.views ?? 0);
      const viewsB = Number(b?.counters?.views ?? b?.views ?? 0);
      return viewsB - viewsA;
    }

    const dateA = new Date(a?.lastActivityAt || a?.updatedAt || a?.createdAt || 0).getTime();
    const dateB = new Date(b?.lastActivityAt || b?.updatedAt || b?.createdAt || 0).getTime();
    return dateB - dateA;
  });
  const localizedSignName = (signKey) => {
    const zodiacKey = HOME_ZODIAC_KEY_BY_FORUM_SIGN[signKey];
    return zodiacKey ? translate(`home:zodiacSigns.${zodiacKey}`) : String(signKey || '');
  };
  const activeSignName = localizedSignName(sign);
  const activeSortLabel = translate(
    SORT_TABS.find((tab) => tab.key === sortKey)?.translationKey || 'sort.recent'
  );

  return (
    <HelmetProvider>
      <div id="forumCategoryRoot" style={styles.page}>
      <div className="forumCategoryWheel" aria-hidden="true" />
        <Helmet>
          <title>{translate('helmet.title', { sign: activeSignName || translate('labels.forum') })}</title>
          <meta
            name="description"
            content={translate('helmet.description', {
              sign: activeSignName || translate('helmet.community'),
            })}
          />
          <link
            rel="canonical"
            href={`https://zodiacus.app/foro/${encodeURIComponent(String(sign || '').trim() || 'foro')}`}
          />
        </Helmet>

        <div style={styles.shell}>
          {/* Top bar */}
          <div className="forumCategoryTopBar" style={styles.topBarRow}>
            <button
              onClick={() => navigate('/foro')}
              onMouseEnter={() => setHoverBack(true)}
              onMouseLeave={() => setHoverBack(false)}
              style={{ ...styles.backBtn, ...(hoverBack ? styles.backBtnHover : null) }}
              title={translate('actions.backToIndex')}
              aria-label={translate('actions.backToIndex')}
            >
              ← {translate('common:actions.back')}
            </button>

            <button
              onClick={() => navigate(`/foro/${sign}/nuevo`)}
              onMouseEnter={() => setHoverCta(true)}
              onMouseLeave={() => setHoverCta(false)}
              style={{ ...styles.newThreadBtn, ...(hoverCta ? styles.ctaBtnHover : null) }}
              title={translate('actions.createThread')}
              aria-label={translate('actions.createThread')}
            >
              + {translate('actions.newThread')}
            </button>
          </div>

          <div style={styles.modernHero}>
            <h1 className="forumCategoryTitle" style={styles.modernHeroTitle}>{translate('hero.title')}</h1>
            <div style={styles.modernHeroDivider} aria-hidden="true">
              <span style={styles.modernHeroLine} />
              <span style={styles.modernHeroStar}>✦</span>
              <span style={styles.modernHeroLine} />
            </div>
          </div>

          <div className="forumCategoryTabs" style={styles.modernTabsShell}>
            {SORT_TABS.map((tab) => {
              const active = tab.key === sortKey;
              return (
                <button
                  key={tab.key}
                  type="button"
                  onClick={() => setSortKey(tab.key)}
                  style={{ ...styles.modernTab, ...(active ? styles.modernTabActive : null) }}
                  aria-pressed={active}
                >
                  {tab.prefix}{translate(tab.translationKey)}
                </button>
              );
            })}
          </div>

          <div style={styles.modernSortHint} aria-live="polite">
            {translate('sort.hint', { order: activeSortLabel })}
            <span style={styles.modernChevron} aria-hidden="true">⌄</span>
          </div>

          {/* Zodiac category carousel */}
          <div style={styles.categoryCarouselWrap} className="forumCategoryCarouselWrap">
            <button
              type="button"
              className="forumCategoryArrow forumCategoryArrowLeft"
              style={{
                ...styles.categoryArrow,
                ...styles.categoryArrowLeft,
                ...(!carouselState.canLeft ? styles.categoryArrowDisabled : null),
              }}
              onClick={() => scrollCategoryCarousel('left')}
              aria-label={translate('carousel.previous')}
              disabled={!carouselState.canLeft}
            >
              <span style={styles.categoryArrowIcon} aria-hidden="true">‹</span>
            </button>

            <div
              ref={categoryScrollerRef}
              className="forumCategoryScroller"
              style={styles.categoryScroller}
              aria-label={translate('carousel.label')}
              onScroll={updateCarouselState}
            >
              {FORUM_SIGNS.map((s) => {
                const isActive = s === sign;
                const signName = localizedSignName(s);
                const shownTotal = categoryTotals?.[s] ?? 0;
                return (
                  <Link
                    key={s}
                    to={`/foro/${s}`}
                    data-forum-sign={s}
                    aria-current={isActive ? 'page' : undefined}
                    style={{ ...styles.categoryCard, ...(isActive ? styles.categoryCardActive : null) }}
                  >
                    <span style={{ ...styles.categoryIcon, ...(isActive ? styles.categoryIconActive : null) }} aria-hidden="true">
                      {EMOJI?.[s] || '✦'}
                    </span>
                    <span style={styles.categoryName}>{translate('category.forumOf')}<br />{signName}</span>
                    <span style={styles.categoryCount}>
                      {shownTotal == null ? '—' : translate('category.threadCount', { count: shownTotal })}
                    </span>
                    <span style={styles.categoryPill}>🪐 {translate('category.openDebates')}</span>
                  </Link>
                );
              })}
            </div>

            <button
              type="button"
              className="forumCategoryArrow forumCategoryArrowRight"
              style={{
                ...styles.categoryArrow,
                ...styles.categoryArrowRight,
                ...(!carouselState.canRight ? styles.categoryArrowDisabled : null),
              }}
              onClick={() => scrollCategoryCarousel('right')}
              aria-label={translate('carousel.next')}
              disabled={!carouselState.canRight}
            >
              <span style={styles.categoryArrowIcon} aria-hidden="true">›</span>
            </button>
          </div>

          {/* Card container */}
          <div style={styles.card} className="forumThreadList">
            {err && (
              <div style={styles.error}>
                {err === FORUM_LOAD_ERROR ? translate('errors.load') : err}
              </div>
            )}

            {loading ? (
              <ul style={styles.list} aria-busy="true" aria-label={translate('common:states.loading')}>
                {Array.from({ length: 6 }).map((_, i) => (
                  <li key={i} style={styles.li}>
                    <div style={styles.skelThread}>
                      <div style={styles.skelTitle} />
                      <div style={styles.skelMeta} />
                    </div>
                  </li>
                ))}
              </ul>
            ) : sortedItems.length === 0 ? (
              <div style={styles.empty}>
                <div style={styles.emptyEmoji}>📝</div>
                <div style={styles.emptyTitle}>{translate('empty.title')}</div>
                <div style={styles.emptySub}>{translate('empty.description')}</div>
                <button onClick={() => navigate(`/foro/${sign}/nuevo`)} style={styles.ctaGhost}>{translate('empty.action')}</button>
              </div>
            ) : (
              <ul style={styles.list} className="forumThreadList">
                {sortedItems.map((t, idx) => {
                  const avatarSrc = getThreadAuthorAvatar(t);
                  const displayedAuthor = authorLabel(t, translate('thread.authorFallback'));
                  const avatarFallback = String(displayedAuthor || '?').trim().slice(0, 1).toUpperCase();

                  return (
                  <li key={t._id} style={styles.li}>
                    <Link
                      to={`/foro/tema/${t.slug}`}
                      style={styles.threadLink}
                      onMouseEnter={() => setHoverItem(t._id)}
                      onMouseLeave={() => setHoverItem(null)}
                    >
                      <div
                        className="forumThreadCard"
                        style={{
                          ...styles.thread,
                          ...(hoverItem === t._id ? styles.threadHover : null),
                          ...(idx % 2 ? styles.threadAlt : null),
                        }}
                      >
                        <div style={styles.threadAvatar} aria-hidden="true">
                          {avatarSrc ? (
                            <img
                              src={avatarSrc}
                              alt=""
                              loading="lazy"
                              referrerPolicy="no-referrer"
                              style={styles.threadAvatarImg}
                              onError={(event) => {
                                event.currentTarget.style.display = 'none';
                                const parent = event.currentTarget.parentElement;
                                if (parent) parent.textContent = avatarFallback;
                              }}
                            />
                          ) : (
                            avatarFallback
                          )}
                        </div>
                        <div style={styles.threadLeft}>
                          <div style={styles.tTitle} title={t.title}>
                            {String(t.title || '').trim()}
                          </div>
                          <div style={styles.meta}>
                            <span style={styles.metaChip}>
                              {EMOJI?.[t.categoryKey] || '✦'} {localizedSignName(t.categoryKey) || translate('labels.forum')}
                            </span>
                            <span style={styles.metaDot}>•</span>
                            <span style={styles.metaChip}>{displayedAuthor}</span>
                            <span style={styles.metaDot}>•</span>
                            <span style={styles.metaChip}>
                              {translate('thread.replyCount', {
                                count: Number(t.counters?.visiblePosts ?? t.counters?.posts ?? t.postsCount ?? t.replies ?? 0),
                              })}
                            </span>
                            <span style={styles.metaDot}>•</span>
                            <span style={styles.metaChip}>
                              {translate('thread.viewCount', { count: Number(t.counters?.views || 0) })}
                            </span>
                            <span style={styles.metaDot}>•</span>
                            {(() => {
                              const replies = (t.counters?.visiblePosts ?? t.counters?.posts ?? t.postsCount ?? t.replies ?? 0);
                              const st = threadStatus(replies);
                              return (
                                <span style={{ ...styles.statusPill, ...styles['status_' + st.kind] }} title={translate('thread.status.title')}>
                                  {translate(st.translationKey)}
                                </span>
                              );
                            })()}
                          </div>
                        </div>
                        <div style={styles.threadRight} aria-hidden="true">→</div>
                      </div>
                    </Link>
                  </li>
                  );
                })}
              </ul>
            )}

            {!loading && totalPages > 1 && (
              <div style={styles.pager}>
                <button
                  style={{
                    ...styles.pagerBtn,
                    ...(page<=1 ? styles.pagerBtnDisabled : null),
                    ...(hoverPrev && page>1 ? styles.pagerBtnHover : null)
                  }}
                  disabled={page<=1}
                  onClick={() => setPage(p => p-1)}
                  onMouseEnter={() => setHoverPrev(true)}
                  onMouseLeave={() => setHoverPrev(false)}
                >
                  ← {translate('pagination.previous')}
                </button>
                <span style={styles.pagerInfo}>{translate('pagination.page', { page, totalPages })}</span>
                <button
                  style={{
                    ...styles.pagerBtn,
                    ...(page>=totalPages ? styles.pagerBtnDisabled : null),
                    ...(hoverNext && page<totalPages ? styles.pagerBtnHover : null)
                  }}
                  disabled={page>=totalPages}
                  onClick={() => setPage(p => p+1)}
                  onMouseEnter={() => setHoverNext(true)}
                  onMouseLeave={() => setHoverNext(false)}
                >
                  {translate('pagination.next')} →
                </button>
              </div>
            )}
          </div>
          <style>{`
            @keyframes shimmer { 0%{background-position:-200% 0} 100%{background-position:200% 0} }
          
@keyframes forumCategoryWheelSpin {
  from { rotate: 0deg; }
  to { rotate: 360deg; }
}

#forumCategoryRoot::before {
  content: "";
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background-image:
    radial-gradient(circle, rgba(255,226,138,.72) 0 1px, transparent 1.45px),
    radial-gradient(circle, rgba(255,255,255,.38) 0 1px, transparent 1.35px),
    linear-gradient(180deg, rgba(0,0,0,.02), rgba(0,0,0,.56));
  background-size: 112px 112px, 174px 174px, 100% 100%;
  opacity: .42;
}

#forumCategoryRoot .forumCategoryWheel {
  position: fixed;
  top: 46%;
  left: 50%;
  width: min(96vmin, 860px);
  height: min(96vmin, 860px);
  translate: -50% -50%;
  border-radius: 50%;
  background: url("/logo/Zodiacus.jpeg") center/contain no-repeat;
  opacity: .22;
  filter: brightness(1.14) saturate(1.06) drop-shadow(0 0 44px rgba(154,47,255,.22));
  z-index: 0;
  pointer-events: none;
  transform-origin: 50% 50%;
  animation: forumCategoryWheelSpin 180s linear infinite;
  -webkit-mask-image: radial-gradient(circle at 50% 50%, #000 94%, transparent 100%);
  mask-image: radial-gradient(circle at 50% 50%, #000 94%, transparent 100%);
}

#forumCategoryRoot .forumThreadCard::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  pointer-events: none;
  background:
    radial-gradient(circle at 14% 18%, rgba(255,216,118,.08), transparent 28%),
    radial-gradient(circle at 86% 72%, rgba(188,69,255,.10), transparent 36%);
}

#forumCategoryRoot .forumThreadCard > * {
  position: relative;
  z-index: 2;
}

#forumCategoryRoot .forumCategoryScroller,
#forumCategoryRoot .forumThreadList {
  scrollbar-width: none;
}

#forumCategoryRoot .forumCategoryScroller::-webkit-scrollbar,
#forumCategoryRoot .forumThreadList::-webkit-scrollbar {
  display: none;
}

#forumCategoryRoot .forumCategoryTabs button,
#forumCategoryRoot .forumCategoryScroller a,
#forumCategoryRoot .forumThreadCard {
  -webkit-tap-highlight-color: transparent;
}

#forumCategoryRoot .forumCategoryCarouselWrap::before,
#forumCategoryRoot .forumCategoryCarouselWrap::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 6px;
  width: 54px;
  pointer-events: none;
  z-index: 3;
}

#forumCategoryRoot .forumCategoryCarouselWrap::before {
  left: -22px;
  background: linear-gradient(90deg, rgba(5,1,15,0.92), rgba(5,1,15,0));
}

#forumCategoryRoot .forumCategoryCarouselWrap::after {
  right: -22px;
  background: linear-gradient(270deg, rgba(5,1,15,0.92), rgba(5,1,15,0));
}

#forumCategoryRoot .forumCategoryArrow {
  animation: forumCategoryArrowPulse 2.6s ease-in-out infinite;
}

#forumCategoryRoot .forumCategoryArrow:disabled {
  animation: none;
}

#forumCategoryRoot .forumCategoryArrow:not(:disabled):active {
  transform: translateY(-50%) scale(0.96);
}

@keyframes forumCategoryArrowPulse {
  0%, 100% { opacity: .76; }
  50% { opacity: 1; }
}

@media (max-width: 520px) {
  #forumCategoryRoot {
    padding: calc(env(safe-area-inset-top, 0px) + 82px) 16px calc(env(safe-area-inset-bottom, 0px) + 96px) !important;
  }

  #forumCategoryRoot .forumCategoryWheel {
    top: 42% !important;
    width: min(108vw, 78svh) !important;
    height: min(108vw, 78svh) !important;
    opacity: .24 !important;
  }

  #forumCategoryRoot .forumCategoryTopBar button {
    min-height: 46px !important;
    border-radius: 17px !important;
    padding-left: 15px !important;
    padding-right: 15px !important;
  }

  #forumCategoryRoot .forumCategoryTitle {
    font-size: clamp(2.35rem, 11vw, 3.05rem) !important;
  }

  #forumCategoryRoot .forumCategoryCarouselWrap::before,
  #forumCategoryRoot .forumCategoryCarouselWrap::after {
    width: 42px !important;
  }

  #forumCategoryRoot .forumCategoryArrow {
    width: 38px !important;
    height: 48px !important;
  }

  #forumCategoryRoot .forumCategoryArrowLeft {
    left: -5px !important;
  }

  #forumCategoryRoot .forumCategoryArrowRight {
    right: -5px !important;
  }
}

`}</style>
        </div>
      </div>
    </HelmetProvider>
  );
}

const styles = {
  page: {
    minHeight: '100svh',
    position: 'relative',
    isolation: 'isolate',
    overflowX: 'hidden',
    background: '#05010F',
    padding: '96px 22px 96px',
    boxSizing: 'border-box',
    color: '#FFF6D8',
  },

  shell: {
    width: '100%',
    maxWidth: 1040,
    margin: '0 auto',
    padding: 0,
    position: 'relative',
    zIndex: 2,
  },

  topBarRow: {
    position: 'fixed',
    top: 'calc(env(safe-area-inset-top, 0px) + 18px)',
    left: 22,
    right: 22,
    zIndex: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 14,
    background: 'transparent',
    boxShadow: 'none',
    padding: 0,
    pointerEvents: 'none',
  },

  backBtn: {
    minHeight: 48,
    padding: '0 18px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    borderRadius: 18,
    border: '1px solid rgba(232,95,255,0.52)',
    background: 'linear-gradient(180deg, rgba(18,5,42,0.88), rgba(8,2,24,0.94))',
    color: '#FFE08B',
    fontWeight: 900,
    textDecoration: 'none',
    cursor: 'pointer',
    boxShadow: '0 0 24px rgba(190,60,255,0.26), 0 12px 30px rgba(0,0,0,0.30), inset 0 1px 0 rgba(255,255,255,0.08)',
    backdropFilter: 'blur(14px)',
    WebkitBackdropFilter: 'blur(14px)',
    pointerEvents: 'auto',
  },
  backBtnHover: {
    transform: 'translateY(-1px)',
    boxShadow: '0 0 28px rgba(190,60,255,0.34), 0 14px 34px rgba(0,0,0,0.32)',
  },

  newThreadBtn: {
    minHeight: 48,
    padding: '0 18px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    borderRadius: 18,
    border: '1px solid rgba(255,226,138,0.62)',
    background: 'linear-gradient(135deg, #FFE28A 0%, #FFD76A 38%, #FFB938 100%)',
    color: '#2A073D',
    fontWeight: 950,
    textDecoration: 'none',
    cursor: 'pointer',
    boxShadow: '0 12px 30px rgba(218,165,32,0.28), inset 0 1px 0 rgba(255,255,255,0.38)',
    pointerEvents: 'auto',
  },
  ctaBtnHover: {
    transform: 'translateY(-1px)',
    boxShadow: '0 14px 34px rgba(218,165,32,0.34), inset 0 1px 0 rgba(255,255,255,0.42)',
  },

  modernHero: {
    width: '100%',
    maxWidth: 720,
    margin: '0 auto 18px',
    textAlign: 'center',
    position: 'relative',
    zIndex: 2,
  },
  modernHeroTitle: {
    margin: 0,
    color: '#FFD979',
    fontWeight: 600,
    fontSize: 'clamp(2.6rem, 7vw, 4.3rem)',
    letterSpacing: '-0.035em',
    lineHeight: 0.98,
    textShadow: '0 0 26px rgba(218,165,32,0.20)',
    fontFamily: "'Cinzel', 'Cormorant Garamond', serif",
  },
  modernHeroDivider: {
    margin: '14px auto 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    color: '#FFD979',
  },
  modernHeroLine: {
    height: 1,
    flex: 1,
    maxWidth: 170,
    background: 'linear-gradient(90deg, transparent, rgba(255,217,121,0.70), rgba(232,95,255,0.22), transparent)',
  },
  modernHeroStar: {
    fontSize: 20,
    filter: 'drop-shadow(0 0 12px rgba(255,217,121,0.36))',
  },

  modernTabsShell: {
    width: '100%',
    maxWidth: 720,
    margin: '0 auto 20px',
    padding: 7,
    borderRadius: 24,
    border: '1px solid rgba(232,95,255,0.32)',
    background: 'linear-gradient(180deg, rgba(20,5,42,0.46), rgba(8,2,24,0.58))',
    boxShadow: '0 18px 42px rgba(0,0,0,0.24), inset 0 1px 0 rgba(255,255,255,0.06)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: 6,
    position: 'relative',
    zIndex: 2,
  },
  modernTab: {
    minHeight: 44,
    border: 'none',
    borderRadius: 18,
    background: 'transparent',
    color: 'rgba(255,255,255,0.74)',
    fontWeight: 800,
    cursor: 'pointer',
  },
  modernTabActive: {
    color: '#FFF6D8',
    background: 'linear-gradient(135deg, rgba(138,43,226,0.76), rgba(75,0,130,0.62))',
    boxShadow: '0 0 24px rgba(186,85,255,0.34), inset 0 1px 0 rgba(255,255,255,0.08)',
  },
  modernSortHint: {
    width: '100%',
    maxWidth: 720,
    margin: '0 auto 14px',
    color: 'rgba(255,255,255,0.84)',
    fontWeight: 700,
    fontSize: 14,
    position: 'relative',
    zIndex: 2,
  },
  modernChevron: {
    color: '#FFD979',
    fontSize: 24,
    marginLeft: 8,
    lineHeight: 1,
  },

  categoryCarouselWrap: {
    width: 'calc(100% + 44px)',
    margin: '0 -22px 24px',
    position: 'relative',
    zIndex: 2,
  },
  categoryArrow: {
    position: 'absolute',
    top: '50%',
    width: 44,
    height: 58,
    transform: 'translateY(-50%)',
    borderRadius: 999,
    border: '1px solid rgba(255,217,121,0.36)',
    background: 'linear-gradient(180deg, rgba(28,6,58,0.84), rgba(8,2,24,0.92))',
    color: '#FFE08B',
    boxShadow: '0 0 24px rgba(190,60,255,0.26), 0 12px 28px rgba(0,0,0,0.34), inset 0 1px 0 rgba(255,255,255,0.08)',
    backdropFilter: 'blur(14px)',
    WebkitBackdropFilter: 'blur(14px)',
    cursor: 'pointer',
    zIndex: 5,
    display: 'grid',
    placeItems: 'center',
    padding: 0,
    transition: 'opacity .16s ease, transform .14s ease, border-color .16s ease, box-shadow .16s ease',
    WebkitTapHighlightColor: 'transparent',
    touchAction: 'manipulation',
  },
  categoryArrowLeft: {
    left: 4,
  },
  categoryArrowRight: {
    right: 4,
  },
  categoryArrowIcon: {
    display: 'block',
    fontSize: 40,
    lineHeight: 0.82,
    fontWeight: 900,
    color: '#FFE28A',
    textShadow: '0 0 14px rgba(255,217,121,0.42)',
    transform: 'translateY(-1px)',
  },
  categoryArrowDisabled: {
    opacity: 0,
    pointerEvents: 'none',
  },
  categoryScroller: {
    width: '100%',
    margin: 0,
    padding: '0 22px 6px',
    display: 'flex',
    gap: 14,
    overflowX: 'auto',
    scrollBehavior: 'smooth',
    scrollSnapType: 'x proximity',
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    zIndex: 2,
  },
  categoryCard: {
    flex: '0 0 176px',
    minHeight: 226,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    textDecoration: 'none',
    color: '#FFF6D8',
    borderRadius: 26,
    border: '1px solid rgba(217,93,255,0.30)',
    background: 'linear-gradient(135deg, rgba(45,7,85,0.44), rgba(12,2,34,0.64))',
    boxShadow: '0 14px 34px rgba(0,0,0,0.18), inset 0 1px 0 rgba(255,255,255,0.06)',
    backdropFilter: 'blur(5px)',
    WebkitBackdropFilter: 'blur(5px)',
    padding: '18px 14px',
    scrollSnapAlign: 'center',
  },
  categoryCardActive: {
    border: '1px solid rgba(255,217,121,0.88)',
    boxShadow: '0 0 28px rgba(255,217,121,0.24), 0 14px 34px rgba(0,0,0,0.24)',
  },
  categoryIcon: {
    width: 64,
    height: 64,
    borderRadius: 999,
    display: 'grid',
    placeItems: 'center',
    color: '#FFD979',
    fontSize: 34,
    border: '1px solid rgba(255,217,121,0.48)',
    background: 'radial-gradient(circle at 35% 24%, rgba(190,80,255,0.62), rgba(35,6,70,0.90) 64%, rgba(5,1,18,0.96) 100%)',
    boxShadow: '0 0 24px rgba(190,80,255,0.32), inset 0 0 14px rgba(255,218,116,0.08)',
  },
  categoryIconActive: {
    border: '1px solid rgba(255,217,121,0.92)',
    boxShadow: '0 0 28px rgba(255,217,121,0.26), 0 0 24px rgba(190,80,255,0.30)',
  },
  categoryName: {
    color: '#FFD979',
    fontFamily: "'Cinzel', Georgia, serif",
    fontWeight: 850,
    fontSize: 21,
    lineHeight: 1.1,
    textAlign: 'center',
  },
  categoryCount: {
    color: 'rgba(255,255,255,0.78)',
    fontWeight: 700,
  },
  categoryPill: {
    minHeight: 28,
    padding: '0 10px',
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 999,
    background: 'rgba(255,255,255,0.055)',
    color: '#FFE08B',
    fontSize: 12,
    fontWeight: 850,
  },

  card: {
    width: '100%',
    maxWidth: 860,
    margin: '0 auto',
    background: 'transparent',
    borderRadius: 0,
    padding: 0,
    boxShadow: 'none',
    border: 'none',
    backdropFilter: 'none',
    overflow: 'visible',
    position: 'relative',
    zIndex: 2,
  },

  error: { color: '#ffb4c2', marginTop: 8 },
  empty: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px 16px',
    color: '#FFF6D8',
  },
  emptyEmoji: { fontSize: 42, marginBottom: 8 },
  emptyTitle: { fontWeight: 900, fontSize: 18 },
  emptySub: { color: 'rgba(255,255,255,0.72)', marginTop: 4, marginBottom: 12 },
  ctaGhost: {
    border: '1px solid rgba(255,226,138,0.52)',
    background: 'linear-gradient(135deg, rgba(255,226,138,0.18), rgba(138,43,226,0.12))',
    color: '#FFE08B',
    fontWeight: 900,
    padding: '10px 14px',
    borderRadius: 14,
    cursor: 'pointer',
  },

  list: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 14,
  },
  li: { padding: 0, margin: 0 },
  threadLink: { textDecoration: 'none', color: 'inherit' },
  thread: {
    position: 'relative',
    overflow: 'hidden',
    display: 'grid',
    gridTemplateColumns: '58px minmax(0, 1fr) 34px',
    alignItems: 'center',
    gap: 14,
    minHeight: 138,
    padding: '20px 20px',
    borderRadius: 24,
    color: '#FFF6D8',
    background: 'linear-gradient(135deg, rgba(45,7,85,0.44), rgba(12,2,34,0.64))',
    border: '1px solid rgba(217,93,255,0.34)',
    boxShadow: '0 14px 34px rgba(0,0,0,0.22), inset 0 1px 0 rgba(255,255,255,0.06)',
    backdropFilter: 'blur(5px)',
    WebkitBackdropFilter: 'blur(5px)',
    transition: 'transform .10s ease, box-shadow .14s ease, border-color .14s ease',
  },
  threadHover: {
    transform: 'translateY(-1px)',
    border: '1px solid rgba(232,95,255,0.58)',
    boxShadow: '0 18px 42px rgba(0,0,0,0.28), 0 0 26px rgba(190,80,255,0.18)',
  },
  threadAlt: {},
  threadAvatar: {
    width: 54,
    height: 54,
    borderRadius: 999,
    display: 'grid',
    placeItems: 'center',
    background: 'radial-gradient(circle at 35% 24%, rgba(255,217,121,0.20), rgba(138,43,226,0.26) 58%, rgba(5,1,18,0.72) 100%)',
    border: '1px solid rgba(255,217,121,0.42)',
    color: '#FFD979',
    fontWeight: 950,
    fontSize: 20,
  },
  threadAvatarImg: {
    width: '100%',
    height: '100%',
    display: 'block',
    objectFit: 'cover',
    borderRadius: 'inherit',
  },
  threadLeft: { minWidth: 0 },
  tTitle: {
    margin: 0,
    color: '#FFF7EA',
    fontFamily: "'Cinzel', Georgia, serif",
    fontSize: 'clamp(1.12rem, 4.7vw, 1.52rem)',
    lineHeight: 1.12,
    fontWeight: 800,
    textShadow: '0 2px 16px rgba(0,0,0,0.38)',
    wordBreak: 'normal',
    overflowWrap: 'break-word',
  },
  meta: {
    marginTop: 12,
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    alignItems: 'center',
    color: 'rgba(255,255,255,0.76)',
  },
  metaChip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    minHeight: 28,
    padding: '0 10px',
    borderRadius: 999,
    border: '1px solid rgba(255,226,138,0.16)',
    background: 'rgba(255,255,255,0.045)',
    color: 'rgba(255,255,255,0.80)',
    fontWeight: 750,
    fontSize: 13,
  },
  metaDot: { color: '#FFD979' },
  statusPill: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    minHeight: 28,
    padding: '0 10px',
    borderRadius: 999,
    fontWeight: 850,
    fontSize: 13,
    color: '#F4D1FF',
    border: '1px solid rgba(190,80,255,0.22)',
    background: 'linear-gradient(135deg, rgba(138,43,226,0.22), rgba(75,0,130,0.16))',
  },
  status_active: {},
  status_open: {},
  status_live: {},
  status_none: {},
  status_openHero: {},
  threadRight: {
    color: '#D45CFF',
    fontSize: 38,
    lineHeight: 1,
    textShadow: '0 0 18px rgba(212,92,255,0.55)',
    justifySelf: 'end',
  },

  pager: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, marginTop: 18 },
  pagerBtn: {
    border: '1px solid rgba(255,226,138,0.52)',
    background: 'linear-gradient(135deg, rgba(255,226,138,0.18), rgba(138,43,226,0.12))',
    color: '#FFE08B',
    padding: '10px 14px',
    borderRadius: 12,
    cursor: 'pointer',
    fontWeight: 900,
  },
  pagerBtnDisabled: { opacity: 0.55, cursor: 'default' },
  pagerBtnHover: { transform: 'translateY(-1px)' },
  pagerInfo: { color: '#FFE08B', fontWeight: 800 },

  skelThread: {
    padding: '16px 14px',
    borderRadius: 18,
    border: '1px solid rgba(217,93,255,0.24)',
    background: 'linear-gradient(90deg, rgba(255,255,255,0.04) 25%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.04) 75%)',
    backgroundSize: '200% 100%',
    animation: 'shimmer 1.2s linear infinite',
  },
  skelTitle: { height: 16, width: '75%', borderRadius: 8, background: 'rgba(255,255,255,0.12)', marginBottom: 10 },
  skelMeta: { height: 12, width: '45%', borderRadius: 8, background: 'rgba(255,255,255,0.08)' },
};
